import { PauseCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const PauseCircle = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <PauseCircleIcon {...rest} size={Sizes[size]} color={fill} />;
};

PauseCircle.displayName = 'PauseCircle';
